import { observable, action, computed, makeObservable, override } from 'mobx';

import { SearchSerializer } from 'utils';

import { Coupon as CouponModel } from 'models';

import { Loadable } from './loadable';

class Coupon extends Loadable<CouponType, FiltersType> {
  defaultFilters: FiltersType = {
    with: 'distances;race.currency',
    limit: 30,
    orderBy: 'id',
    sortedBy: 'desc',
    searchJoin: 'AND',
  };

  declare filters: FiltersType;

  @observable
  handlers = {
    id: 'between',
    name: 'like',
    code: 'like',
    qty: 'between',
    discount_amount: 'between',
    'race.translations.name': 'like',
    'distances.translations.name': 'like',
    date_from: '<=',
    status: '=',
    description: 'like',
  };

  static allowBlank: string[] = [];

  constructor() {
    super();

    makeObservable(this);
    this.filters = this.defaultFilters;
  }

  @action
  updateSearch(search: string, searchFields: string): void {
    if (!search) {
      this.filters.search = null as any;
      this.filters.searchFields = null as any;
      delete this.filters.search;
      delete this.filters.searchFields;
    } else {
      this.filters.search = search;
      this.filters.searchFields = searchFields;
    }
  }

  @action
  updateSearchHandlers(
    newHandlers: {
      [K in string]: string;
    },
  ) {
    this.handlers = {
      ...this.handlers,
      ...newHandlers,
    };
  }

  @computed
  get searchDataModel(): SearchSerializer {
    const search = this.filters.search as any;
    return new SearchSerializer(search, this.handlers, Coupon.allowBlank);
  }

  retrieveSearchDataModel(): SearchSerializer {
    return this.searchDataModel.clone();
  }

  @computed
  get modelValues(): Array<CouponModel> {
    return this.values.map((race) => new CouponModel(race));
  }

  @override
  clearAll() {
    super.clearAll();
    this.filters = this.defaultFilters;
  }

  @computed
  get modelSelected(): null | CouponModel {
    const selected = this.selected;

    if (!selected) {
      return null;
    }

    return new CouponModel(selected);
  }
}

export { Coupon };
export default new Coupon();
